import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaTarefa} from "../models/lista-tarefa";
import {NovaTarefa} from "../models/nova-tarefa";
import {TarefaDetalhes} from "../models/tarefa-detalhes";
import {AlteraTarefa} from "../models/altera-tarefa";
import {AtribuiTarefa} from "../models/atribui-tarefa";
import {TarefasAgrupadasPorHora} from "../models/tarefas-agrupadas-por-hora";
import {NovoComentario} from "../../../core/models/novo-comentario";
import {environment} from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class TarefaService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`TarefaService`);
  }

  baseUrl = environment.apiUrl;

  minhasTarefas(): Observable<BaseResponse<ListaTarefa> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaTarefa>>(`${this.baseUrl}/Tarefa/Minhas`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('minhasTarefas')));
  }

  adicionar(request: NovaTarefa): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  buscarPorId(id: number): Observable<BaseResponse<TarefaDetalhes> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<TarefaDetalhes>>(`${this.baseUrl}/Tarefa/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorId')));
  }

  buscarPorResponsavel(responsavel: number): Observable<BaseResponse<ListaTarefa> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaTarefa>>(`${this.baseUrl}/Tarefa/PorResponsavel/${responsavel}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorResponsavel')));
  }

  alterar(request: AlteraTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterar')));
  }

  alterarStatus(request: AtribuiTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/AlterarStatus`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterarStatus')));
  }

  atribuir(request: AtribuiTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/Atribuir`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('Atribuir')));
  }

  deletar(id: number): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/` + id)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('deletar')));
  }

  finalizar(request: AtribuiTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/Finalizar`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('finalizar')));
  }

  iniciar(request: AtribuiTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/Iniciar`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('iniciar')));
  }

  buscarCompromissosDiario(dataHoje: String){
    return this.http
      .get<BaseResponse<ListaTarefa>>(`${this.baseUrl}/Tarefa/BuscarCompromissosPorDia/${dataHoje}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarCompromissosDiario')));
  }

  buscarCompromissosDiarioAgrupadoPorHora(dataHoje: String){
    return this.http
      .get<BaseResponse<TarefasAgrupadasPorHora>>(`${this.baseUrl}/Tarefa/BuscarCompromissosPorDiaAgrupadoPorHora/${dataHoje}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('BuscarCompromissosPorDiaAgrupadoPorHora')));
  }

  atribuirTarefa(request: AtribuiTarefa): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/Atribuir`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('atribuirTarefa')));
  }

  adicionarComentario(request: NovoComentario): Observable<BaseResponse<boolean> |BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Tarefa/AdicionarComentario`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionarComentario')));
  }
}

